import React, {FC} from 'react';

import QuestionRadio from '../../components/QuestionRadio';
import {AGE_OPTIONS} from '../../constants';

const StepAge: FC = () => <QuestionRadio field="age" options={AGE_OPTIONS} />;

export default StepAge;
